import format from "date-fns/format";
import { words } from "lodash";
import React, { useState } from "react";
import Truncate from "react-truncate";
import PlatformIcons from "../logos/social";
import Response from "./Response";
import "./Review.scss";
import "./SingleReview.scss";
import StarRating from "./StarRating";

class CreatedAtDate extends React.Component {
  render() {
    return <span className="time">{format(this.props.time, "M/D/YYYY")}</span>;
  }
}

export const TruncatableText = ({ text, enabled, lines, expandInline, truncateDest = "/reviews" }) => {
  let [expanded, setExpanded] = useState(false);

  var lines = parseInt(lines, 10);
  if (!(lines > 0)) {
    lines = 2;
  }

  if ((enabled && expanded === true) || !enabled) {
    return <p>{text}</p>;
  }

  return expandInline ? (
    <Truncate
      lines={lines}
      ellipsis={
        <span>
          ...{" "}
          <a
            onClick={() => {
              setExpanded(true);
            }}
          >
            read more
          </a>
        </span>
      }
    >
      {text}
    </Truncate>
  ) : (
    <Truncate
      lines={lines}
      ellipsis={
        <span>
          ... <a href={truncateDest}>read more</a>
        </span>
      }
    >
      {text}
    </Truncate>
  );
};

const PublicName = (name) => {
  var names = words(name);
  if (names.length == 1) {
    return name;
  }
  var lastName = names.pop();
  if (lastName) {
    lastName = lastName.charAt(0);
  }
  names.push(lastName);
  return names.join(" ");
};

const nameSpan = (name) => {
  if (name) {
    return <div className="name">{PublicName(name)}</div>;
  }
};

const PlatformIcon = ({ platform }) => {
  return (
    <div className="hr-review-icon">
      <img src={PlatformIcons[platform]} />
    </div>
  );
};

const Review = ({
  comment,
  responses,
  rating,
  name,
  created_at,
  truncateText,
  truncateAt,
  expandInline,
  truncateDest,
  hideResponses,
  platform,
  recommended,
  hidePlatform = false,
}) => {
  return (
    <div className="single-review">
      {!hidePlatform && <PlatformIcon platform={platform || "FIRST_PARTY"} />}
      <div className="review">
        {nameSpan(name)}
        <div>
          {platform === "FACEBOOK" ? (
            recommended ? (
              <div className="recommended">
                <i className="ion ion-checkmark" /> <span>Recommended</span>
              </div>
            ) : null
          ) : (
            <StarRating rating={rating} />
          )}
        </div>
        <div className="comment">
          <TruncatableText
            truncateDest={truncateDest}
            enabled={truncateText}
            text={comment}
            lines={truncateAt}
            expandInline={expandInline}
          />
        </div>
        <div className="meta">
          <CreatedAtDate time={created_at} />
        </div>
        {hideResponses ? null : responses ? [responses[0]].map((response) => <Response key={response.id} response={response} />) : null}
      </div>
    </div>
  );
};

export default Review;



// WEBPACK FOOTER //
// ./src/components/Review.jsx